import { Navigate } from "react-router-dom"
import Login from "../pages/Login"

function banLogin(){
    if(localStorage.access_token || localStorage.getItem('access_token')!=undefined){
        return <Navigate to="/" />
    }

    return <Login />
}

export default banLogin